module.exports = __webpack_public_path__ + "img/poster-1.7e8b0d14.jpg";